/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module ExternalServicesModule */

import {
    Component,
    OnInit,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import './customer-program.component.less';
import { DownloadFileService } from 'ng/modules/core/services/download-file.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as l10n from './customer-program.l10n';
import { CustomerProgramService } from '../../service/customer-program.service';
import { ITelemetryData } from '../../service/customer-program.service.types';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const TELEMETRY_FULL_METRICS_FILENAME = 'Telemetry_full_metrics.json';

/**
 * @description
 * Customer Program component to show telemetry data.
 * @author Shubam Bindal
 */

@Component({
    selector: 'customer-program',
    templateUrl: './customer-program.component.html',
    providers: [CustomerProgramService],
})
export class CustomerProgramComponent implements OnInit {
    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    public telemetryData: ITelemetryData;

    public error: string;

    constructor(
        private readonly l10nService: L10nService,
        private readonly customerProgramService: CustomerProgramService,
        private readonly downloadFileService: DownloadFileService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * @override
     */
    public ngOnInit(): void {
        this.getCustomerProgramData();
    }

    /**
     * Fetch telemetry data for customer program.
     */
    public async getCustomerProgramData(): Promise<void> {
        const configData$ = await this.customerProgramService.loadTelemetryData();

        configData$.subscribe({
            next: (response: ITelemetryData) => {
                this.telemetryData = response;
            },
            error: (error: HttpErrorResponse) => {
                this.error = error.error?.message;
            },
        });
    }

    /**
     * Download telemtry full metrics data as json file.
     */
    public downloadFullMetrics(): void {
        const stringifiedData = JSON.stringify(this.telemetryData, null, 4);

        this.downloadFileService.downloadFile(stringifiedData, TELEMETRY_FULL_METRICS_FILENAME);
    }
}
